import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';

interface EmptyStateProps {
  message?: string;
  isLoading?: boolean;
}

export default function EmptyState({ message = 'No messages yet.', isLoading = false }: EmptyStateProps) {
  return (
    <div className="text-center py-12">
      <ReactPlaceholder
        type="text"
        rows={1}
        ready={!isLoading}
        color="#E0E0E0"
        className="max-w-xs mx-auto"
        showLoadingAnimation
      >
        <p className="text-gray-500 dark:text-gray-400">{message}</p>
      </ReactPlaceholder>
    </div>
  );
}